import {
  SET_REVIEW_QUEUE_AUTHOR_FILTERS,
  SET_REVIEW_QUEUE_KEYWORD_FILTER,
  SET_REVIEW_QUEUE_COURSE_FILTER,
  SET_REVIEW_QUEUE_LEVELS_FILTER,
  SET_REVIEW_QUEUE_SORT_TYPE,
  SET_REVIEW_QUEUE_SORT_ORDER,
  SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW,
  SET_REVIEW_QUEUE_NEED_FINAL_REVIEW,
  SET_REVIEW_QUEUE_ALL_REVIEWS,
  CLEAR_REVIEW_QUEUE_FILTERS,
  SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS
} from '../actions/reviewqueuefilters'

const initialState = {
  state_in: [0, 4],
  authors_id_in: [],
  name_or_description_cont: '',
  mock_course_id_in: null,
  mock_level_id_in: [],
  sort_type: 'quest_priority',
  sort_order: 'desc',
  need_standards_review: false,
  need_final_review: false,
  grade_levels_id_in: []
}

export function reviewqueuefilters(state = initialState, action) {
  switch (action.type) {
    case SET_REVIEW_QUEUE_AUTHOR_FILTERS:
      return Object.assign({}, state, {
        authors_id_in: action.authors_id_in
      })
    case SET_REVIEW_QUEUE_KEYWORD_FILTER:
      return Object.assign({}, state, {
        name_or_description_cont: action.name_or_description_cont
      })
    case SET_REVIEW_QUEUE_COURSE_FILTER:
      return Object.assign({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      })
    case SET_REVIEW_QUEUE_LEVELS_FILTER:
      return Object.assign({}, state, {
        mock_level_id_in: action.mock_level_id_in
      })
    case SET_REVIEW_QUEUE_SORT_TYPE:
      return Object.assign({}, state, {
        sort_type: action.sort
      })
    case SET_REVIEW_QUEUE_SORT_ORDER:
      return Object.assign({}, state, {
        sort_order: action.order
      })
    case SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW:
      return Object.assign({}, state, {
        need_standards_review: true,
        need_final_review: false
      })
    case SET_REVIEW_QUEUE_NEED_FINAL_REVIEW:
      return Object.assign({}, state, {
        need_standards_review: false,
        need_final_review: true
      })
    case SET_REVIEW_QUEUE_ALL_REVIEWS:
      return Object.assign({}, state, {
        need_standards_review: false,
        need_final_review: false
      })
    case CLEAR_REVIEW_QUEUE_FILTERS:
      return Object.assign({}, state, initialState)
    case SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS:
      return Object.assign({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reviewqueuefilters.js